module.exports = __webpack_public_path__ + "img/food-no-gluten.246aa6b5.svg";